export const ActionOperationEnum = {
    Highlight: {
        Models: "HighlightModels",
        Volumes: "HighlightVolumes",
        Branches: "HighlightBranches",
        Groups: "HighlightGroups"
    },
    VISIBILITY: {
        Models: "VisibilityModels",
        Volumes: "VisibilityVolumes",
        Branches: "VisibilityBranches",
        Groups: "VisibilityGroups"
    },
    TRANSPARENCY: {
        Models: "TransparencyModels",
        Volumes: "TransparencyVolumes",
    }
};

export const SelectionObjectTypeEnum = {
    Models: "Models",
    Volumes: "Volumes",
    Branches: "Branches",
    Groups: "Groups"
};
